/**
 * MetricCard — Card de métrica compacto com trend e subtitle
 */
import { T } from '../../styles/tokens';

interface MetricCardProps {
  value: string | number;
  label: string;
  color?: string;
  icon?: any;
  trend?: number;
  subtitle?: string;
}

export function MetricCard({ value, label, color = T.text, icon, trend, subtitle }: MetricCardProps) {
  return (
    <div style={{
      background: T.bgCard,
      border: `1px solid ${T.border}`,
      borderRadius: T.radiusLg,
      padding: `${T.space4}px ${T.space5}px`,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {icon && <div style={{ fontSize: T.textXl, flexShrink: 0 }}>{icon}</div>}
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ fontSize: T.text2xl, fontWeight: T.weightBold, color, letterSpacing: '-0.5px' }}>{value}</div>
            {trend != null && trend !== 0 && (
              <span style={{
                fontSize: T.textXs,
                fontWeight: T.weightSemibold,
                color: trend > 0 ? T.success : T.danger,
                display: 'flex', alignItems: 'center', gap: 2,
              }}>
                {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}%
              </span>
            )}
          </div>
          <div style={{ fontSize: T.textXs, color: T.textMuted, marginTop: 2 }}>{label}</div>
          {subtitle && (
            <div style={{ fontSize: T.textXs, color: T.textSecondary, marginTop: 2 }}>{subtitle}</div>
          )}
        </div>
      </div>
    </div>
  );
}
